/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETAWARDBYID= createAsyncThunk(
  "getAwardById/getAwardById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAwardByIdSlice = createSlice({
  name: "getAwardByIdSlice",
  initialState: {
    getAwardById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAwardById: (state) => {
        state.getAwardById.loading = false
        state.getAwardById.error = false
        state.getAwardById.data = []
        state.getAwardById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETAWARDBYID.fulfilled, (state, action) => {
      state.getAwardById = {
        ...state.getAwardById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAWARDBYID.pending, (state, action) => {
      state.getAwardById = {
        ...state.getAwardById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAWARDBYID.rejected, (state, action) => {
      state.getAwardById = {
        ...state.getAwardById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAwardByIdAction = {
    GETAWARDBYID,
};

export { getAwardByIdAction };
export default getAwardByIdSlice.reducer;
export const {setInitialStateOfgetAwardById} = getAwardByIdSlice.actions